export enum PcrPayScaleTypeEnum {
  CLASSIFIED = 'CLASSIFIED',
  INTERVIEW_DONE = 'INTERVIEW_DONE'
}

export const pcrPayScaleTypeMapping: Record<PcrPayScaleTypeEnum, string> = {
  CLASSIFIED: 'Classé sans suite',
  INTERVIEW_DONE: 'Entretien Réalisé'
}
